/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import {AbstractCase} from "../../../types/Entities/AbstractCase";

const ProbationFine = (props: { traffic: AbstractCase }) => {
  const { traffic } = props;

  const categoryASentence =
    "Achtung, Sie sind in der Probezeit! Dies erhöht die Strafe deutlich! Ihnen droht, zusätzlich zu Bußgeld und Punkten, die Verlängerung der Probezeit und ein Aufbauseminar. Sollte dies bereits der zweite Verstoß in der Probezeit sein, droht Ihnen sogar der Entzug der Fahrerlaubnis!";
  const categoryBSentence =
    "Achtung: Sie befinden sich in der Probezeit! Sollte dies Ihr zweiter Verstoß innerhalb der Probezeit sein, droht Ihnen die Probezeitverlängerung um 2 Jahre und ein Aufbauseminar!";

  //each row is a "whitelist entry"
  if (traffic.accusation === "speeding" && traffic.speeding !== "0-20")
    return (
      <>
        {categoryASentence}
        <br />
        <br />
      </>
    );
  if (traffic.accusation === "distance" && traffic.speed !== "<81")
    return (
      <>
        {categoryASentence}
        <br />
        <br />
      </>
    );
  if (traffic.accusation === "red_light")
    return (
      <>
        {categoryASentence}
        <br />
        <br />
      </>
    );
  if (traffic.accusation === "other" && traffic.accusationOther === "mobile_phone")
    return (
      <>
        {categoryBSentence}
        <br />
        <br />
      </>
    );

  return null;
};

export default ProbationFine;
